import { render, staticRenderFns } from "./AsrRemoteSelect.vue?vue&type=template&id=0ffa1c3c&scoped=true"
import script from "./AsrRemoteSelect.vue?vue&type=script&lang=js"
export * from "./AsrRemoteSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa1c3c",
  null
  
)

export default component.exports